import React, { useEffect, useRef, useState } from "react";
import { isNil } from "ramda";
import { func, bool, object, number } from "prop-types";

import { Button, ModalHeader, Input } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { oidcSelector } from "../../../../../selectors/oidcSelectors";

import {
  watchListMatchStatusOptions,
  MONITORING_QUEUE_ENTRY_TYPES,
} from "../../../constants/monitoringQueueEntryConstants";
import { Modal } from "@material-ui/core";
import "./changeWatchlistEntryMatchStatusModal.css";
import CustomCloseModalButton from "../../../../../components/common/CustomCloseModalButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useRoles from "../../../../../components/hooks/useRoles";
import JSONFormatter from "./JSONFormatter";
import { validateComment } from "../../../../../utilities/common";
import { toggleMQDecisionModal } from "../../../actions/changeDecisionModalsActions";
import { selectModalMQChangeDecisionOpen } from "../../../selectors/changeDecisionModalsSelector";

const ChangeWatchlistEntryMatchStatusModal = ({
  toggle,
  details,
  alldetails,
  type,
  handleConfirm,
  setDataChange,
  url,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isOpen = useSelector(selectModalMQChangeDecisionOpen);
  function parentNotProcessedCheck() {
    const parentNotProcessedID =
      details && details.firstNotProcessedMonitoringqueueId;

    const parentNotProcessedDecisionID =
      details &&
      details.watchListSearchingDecisionDto &&
      details.watchListSearchingDecisionDto
        .parentWatchListSearchingDecisionMonitoringqueueId;

    const parentNegativeMediaID =
      details &&
      details.negativeMediaSearchingDecision &&
      details.negativeMediaSearchingDecision
        .parentNegativeMediaSearchingDecisionMonitoringqueueId;

    return (
      parentNotProcessedID ||
      parentNotProcessedDecisionID ||
      parentNegativeMediaID
    );
  }

  const detailsJson =
    type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
    type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED &&
    !isNil(details) &&
    !isNil(details.matchingEntries)
      ? details.matchingEntries.map((e) => ({
          ...JSON.parse(e.detailsJson),
          matchPercent: e.matchPercent,
        }))
      : "";

  const isNegativeMedia =
    type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
    type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED;

  const [entryStatusValue, setEntryStatusValue] = useState(0);
  const [currentValue, setCurrentValue] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const commentRef = useRef(null);
  const { isCustomerSupport } = useRoles();

  useEffect(() => {
    const commentValid = validateComment(commentRef.current);
    const valueChanged = currentValue !== entryStatusValue;
    if (valueChanged && !isNegativeMedia) {
      setDisabled(false);
    } else {
      commentValid && valueChanged ? setDisabled(false) : setDisabled(true);
    }
  }, [entryStatusValue]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (details && details.watchListSearchingDecisionDto) {
      if (!isNaN(parseInt(details.watchListSearchingDecisionDto.type, 10))) {
        setEntryStatusValue(
          parseInt(details.watchListSearchingDecisionDto.type, 10)
        );
        setCurrentValue(
          parseInt(details.watchListSearchingDecisionDto.type, 10)
        );
      } else {
        setEntryStatusValue(0);
        setCurrentValue(0);
      }
    } else {
      if (details && details.negativeMediaSearchingDecision) {
        setEntryStatusValue(
          parseInt(details.negativeMediaSearchingDecision.type, 10)
        );
        setCurrentValue(
          parseInt(details.negativeMediaSearchingDecision.type, 10)
        );
      } else {
        setEntryStatusValue(0);
        setCurrentValue(0);
      }
    }
  }, [isOpen]);

  const handleCommentChange = (event) => {
    const comment = event.target.value;
    commentRef.current = comment;
    setDisabled(!validateComment(comment));
  };

  const handleEntryStatusChange = (value) => {
    setEntryStatusValue(parseInt(value, 10));
    setDataChange(true);
  };

  const oidc = useSelector(oidcSelector);

  const canChangeWatchlistMatchResolution = !!oidc.user.profile.role.find(
    (x) => {
      return (
        x === "coordinator" ||
        x === "master" ||
        x === "manager" ||
        x === "client"
      );
    }
  );

  const goToParentID = parentNotProcessedCheck();

  const getNegativeMediaUrl = () => {
    if (type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED) {
      var data = JSON.parse(alldetails.clientNegativeMediaCheckResult.dataJson);
      if (data && data.Resolutions) {
        return data.Resolutions[0].ArticleUrl;
      }
    }
    return url;
  };
  const getArticles = () => {
    if (type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED) {
      var data = JSON.parse(alldetails.clientNegativeMediaCheckResult.dataJson);
      if (data && data.Resolutions) {
        return data.Resolutions;
      }
    }
    return [];
  };

  return (
    <Modal open={isOpen}>
      <div className="change-watchlist-entry-modal-main-container">
        <ModalHeader close={<CustomCloseModalButton toggle={toggle} />}>
          <a href={getNegativeMediaUrl()} target="_blank">
            {type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
            details &&
            details.name
              ? details.name
              : "Negative Media Entry"}
          </a>
        </ModalHeader>
        <div className="change-watchlist-entry-modal-content">
          {isNegativeMedia && (
            <div>
              <div>
                <ul>
                  {getArticles().map((data, i) => {
                    return (
                      <li key={i}>
                        <a href={data.ArticleUrl} target="_blank">
                          ({data.PublishedDate}) - ({data.ArticleUrl}) -{" "}
                          {data.Summary} ({data.MatchedCategories.join(",")})
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              {goToParentID ? null : (
                <React.Fragment>
                  <Input
                    ref={commentRef}
                    type="textarea"
                    className="mb-2"
                    placeholder="Comment..."
                    name="comment"
                    onChange={handleCommentChange}
                  />
                  <div className="confirm-info red left">
                    Description should be between 15 and 200 characters.
                  </div>
                </React.Fragment>
              )}
            </div>
          )}
          {type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
            type !==
              MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED && (
              <div>
                {detailsJson
                  ? detailsJson.map((data, i) => {
                      return (
                        <React.Fragment key={i}>
                          {i >= 1 ? <hr /> : null}
                          <JSONFormatter data={data} />
                        </React.Fragment>
                      );
                    })
                  : null}
              </div>
            )}
        </div>
        <div className="change-watchlist-entry-actions">
          {goToParentID ? <GoToParent /> : <ChangeDecision />}
        </div>
      </div>
    </Modal>
  );

  function GoToParent() {
    const handleGoToParent = () => {
      dispatch(toggleMQDecisionModal(false));
      setDataChange(false);
      history.push(
        `?monitoringQueueEntryDetails&entryID=${goToParentID}&type=null`
      );
    };
    return (
      <div className="change-watchlist-entry-go-to-parent-box">
        <div>{"Go to Parent --->"}</div>
        <Button
          onClick={handleGoToParent}
          className="go-to-parent confirm-button"
          color="primary"
        >
          Go to Parent
        </Button>
      </div>
    );
  }

  function ChangeDecision() {
    return (
      <div className="change-watchlist-entry-actions-box">
        <div>
          {details && type !== 1 ? (
            <div className="change-watchlist-entry-decision-options-box">
              <div className="change-watchlist-entry-decision-options-label">
                Change Decision:
              </div>

              {watchListMatchStatusOptions.map((op, i) => {
                const isInReviewButton = i === 0;
                const isAlreadySelected = entryStatusValue !== 0;

                /* disabled variant */
                if (isCustomerSupport) {
                  return (
                    <div
                      key={op.key}
                      style={{ cursor: "not-allowed", opacity: 0.8 }}
                      className={`change-watchlist-entry-decision-options-option`}
                    >
                      {op.label}
                    </div>
                  );
                }

                /* disabled variant */

                return (
                  <div
                    key={op.key}
                    onClick={
                      isInReviewButton && isAlreadySelected
                        ? () => {}
                        : () => handleEntryStatusChange(op.value)
                    }
                    style={
                      isInReviewButton && isAlreadySelected
                        ? { cursor: "default", opacity: 0.8 }
                        : {}
                    }
                    className={`change-watchlist-entry-decision-options-option${
                      entryStatusValue === op.value
                        ? " change-watchlist-entry-decision-options-option-active"
                        : ""
                    }`}
                  >
                    {op.label}
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
        <div
          className={
            type !== 1
              ? "d-flex flex-row justify-content-around "
              : "d-flex flex-row justify-content-end "
          }
        >
          {type !== 1 ? (
            <React.Fragment>
              <Button
                className="change-watchlist-entry-button cancel-button"
                color="secondary"
                onClick={toggle}
              >
                Cancel
              </Button>
              {canChangeWatchlistMatchResolution && (
                <Button
                  className="change-watchlist-entry-button confirm-button"
                  color="primary"
                  onClick={() => {
                    const data =
                      type ===
                        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
                      type ===
                        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
                        ? {
                            type: entryStatusValue,
                            ClientId: details.client.id,
                            comment: commentRef.current,
                            NegativeMediaType:
                              type ===
                              MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO
                                ? "RealTime"
                                : "ElasticBased",
                            isNegativeIgnoringProp: true,
                          }
                        : { type: entryStatusValue, id: details.id };
                    handleConfirm(data);
                    toggle();
                    setEntryStatusValue(0);
                  }}
                  disabled={disabled}
                >
                  save
                </Button>
              )}
            </React.Fragment>
          ) : (
            <Button
              className="change-watchlist-entry-button cancel-button "
              color="secondary"
              onClick={toggle}
            >
              Close
            </Button>
          )}
        </div>
      </div>
    );
  }
};

ChangeWatchlistEntryMatchStatusModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  handleConfirm: func.isRequired,
  details: object,
  type: number,
  setDataChange: func.isRequired,
};

export default ChangeWatchlistEntryMatchStatusModal;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/change-watchlist-entry-match-status-modal/ChangeWatchlistEntryMatchStatusModal.jsx